export const activitiesOptions = [
  { value: 1, label: 'Actividades Artísticas, de Entretenimiento y Recreativas' },
  { value: 2, label: 'Actividades de Alojamiento y de Servicio de Comidas' },
  { value: 3, label: 'Actividades de Atención de la Salud Humana y de Asistencia Social' },
  { value: 4, label: 'Actividades de los Hogares como Empleadores, Actividades No Diferenciadas de los Hogares' },
  { value: 6, label: 'Actividades de Organizaciones y Órganos Extraterritoriales' },
  { value: 7, label: 'Actividades de Servicios Administrativos y de Apoyo' },
  { value: 8, label: 'Actividades Financieras y de Seguros' },
  { value: 9, label: 'Actividades inmobiliarias' },
  { value: 10, label: 'Actividades Profesionales, Científica y Técnicas' },
  { value: 11, label: 'Adm. Pública y Defensa, Planes de Seguridad Social de Afiliación Obligatoria' },
  { value: 12, label: 'Agricultura, Ganadería, Silvicultura y Pesca' },
  { value: 13, label: 'Comercio al Por Mayor y al por Menor' },
  { value: 15, label: 'Construcción' },
  { value: 16, label: 'Enseñanza' },
  { value: 17, label: 'Explotación de Minas y Canteras' },
  { value: 18, label: 'Industrias Manufacturera' },
  { value: 19, label: 'Información y Comunicaciones' },
  { value: 20, label: 'Otras Actividades de Servicios' },
  { value: 14, label: 'Reparación de Vehículos Automotores y Motocicletas' },
  { value: 21, label: 'Suministro de Agua, Evacuación de Agua residuales, gestión de desechos y descontaminación' },
  { value: 22, label: 'Suministro de Electricidad, Gas, Vapor y Aire Acondicionado' },
  { value: 23, label: 'Transporte y Almacenamiento' }
]
